import React, { useState, useEffect } from 'react';
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Header from './header';
import { Icons } from "../../assest/icons";
import { logger } from '../../utils/logger';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import SideBarMenu from './sideBarMenu';
import { getAdminByEmail, createAdmin, updateAdmin, ROLES, ADMIN_PORTAL_ROLES } from '../../services/firestore';
import { fetchWithAppCheck } from '../../utils/fetchWithAppCheck';
 

function AddAdminUser() {
  let navigate = useNavigate();
  const locationi = useLocation(); 
  const [userid, setuserid] = useState(locationi.state);
 
  const [userProfileData, setUserProfileData] = useState([]);
 
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userProfileTxt, setUserProfileTxt] = useState('admin');
  const [roleTxt, setRoleTxt] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [selectedToggle, setSelectedToggle] = useState(true);
  const [DOBTxt, setDOBTxt] = useState('');
  const [InsuranceIdTxt, setInsuranceIdTxt] = useState('');
  const [GenderTxt, setGenderTxt] = useState('');
  const [originalProfile, setOriginalProfile] = useState({});
  const [isEditing, setIsEditing] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  var years = DOBTxt ? moment().diff(DOBTxt) : 0;
  const ageCal = DOBTxt ? moment().diff(DOBTxt, 'years') : 0;

  const [AgeTxt, setAgeTxt] = useState(ageCal);
  const [WeightTxt, setWeightTxt] = useState('');
  const [HeightTxt, setHeightTxt] = useState('');
  const [ShowLoader, setShowLoader] = useState(false);

  const [UserId, setUserId] = useState(userProfileData?.user_id || userProfileData?.id || '');
  const [showCalendar, setShowCalendar] = useState(false);  
  const [isValid, setIsValid] = useState(false);
  const [focused, setFocused] = React.useState(false);
  const [passwordType, setPasswordType] = useState("password");

  const handleClickPassword = (event) => { 
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };
  const handlePasswordChange = (event) => {
    const { value } = event.target;
    setPassword(value);
    setError('');
};
  
  const onChangeCalendar = (date) => {     
    setDOBTxt(formatDate(date));
    setShowCalendar(false); 
};
  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
};
const formatDate = (date) => {
  return date ? moment(date).format("YYYY-MM-DD") : '';
};
const parseDOBToDate = (dob) => {
  if (!dob) return null;
  const m = moment(dob, ['YYYY-MM-DD', 'DD-MM-YYYY']);
  return m.isValid() ? m.toDate() : null;
};
  const handleChangeCancel = () => {
    setIsEditing(!isEditing);
};
const handleGenderChange = (event) => {
  let { value } = event.target; 
      // Allow delete action
      if (value === '') {
        setGenderTxt(''); 
    } 
    // Convert input to uppercase for comparison
    value = value.toUpperCase();
  // Allow only 'M' or 'F' characters
  if ( value === 'M' || value === 'F') { 
      setGenderTxt(value === 'M' ? 'Male' :  'Female');
  }
};
 
const handleEmailChange = (event) => {
  const { value } = event.target;
  setEmail(value);
  setError('');
};

const handleSubmitProfile = async (event) => {
  event.preventDefault();
  
  // Simple form validation
  let formErrors = {};
  if (!fullName.trim()) {
    formErrors.fullName = 'Please enter your full name';
  }
  if (!email.trim()) {
    formErrors.email = 'Please enter your email';
  }
  if (!phoneNumber.trim()) {
    formErrors.phoneNumber = 'Please enter your phone number';
  } else if (phoneNumber.replace(/\D/g, '').length < 10) {
    formErrors.phoneNumber = 'Please enter a valid phone number (at least 10 digits)';
  }
  if (!DOBTxt || !DOBTxt.length) {
    formErrors.DOBTxt = 'Please select a date of birth';
  } else if (ageCal < 18) {
    formErrors.DOBTxt = 'Must be at least 18 years old';
  }
  if (!GenderTxt.trim()) {
    formErrors.GenderTxt = 'Please enter your sex';
  }
  if (!roleTxt) {
    formErrors.roleTxt = 'Please select a role';
  }
  if (!specialty.trim()) {
    formErrors.specialty = 'Please enter your specialty';
  }

  if (Object.keys(formErrors).length > 0) {
    setError(formErrors);
    return;
  }

  setShowLoader(true);

  try {
    // Check if admin already exists
    const existingAdmin = await getAdminByEmail(email);

    if (existingAdmin) {
      toast.error('Admin with this email already exists', {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
      return;
    }

    // Create admin in Firestore (no password — new admin sets their own via reset link)
    const adminId = await createAdmin({
      fullName,
      email,
      phoneNumber,
      dob: DOBTxt,
      gender: GenderTxt,
      age: ageCal,
      specialty,
      role: roleTxt,
      must_change_password: true,
    });

    // Generate secure one-time password-setup token (valid 24 h)
    const resetToken = crypto.randomUUID();
    await updateAdmin(adminId, {
      reset_token: resetToken,
      reset_token_expires_at: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
      must_change_password: true,
    });

    toast.success('Admin created successfully!', {
      position: toast.POSITION.TOP_RIGHT,
    });

    // Send welcome email with secure password-setup link (no plain-text password)
    const roleDisplayName = ADMIN_PORTAL_ROLES[roleTxt] || roleTxt;
    const setupUrl = `https://admin.aigicare.com/admin/reset_password?token=${resetToken}&email=${encodeURIComponent(email)}`;
    const welcomeHtml = `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <h2 style="color: #024C9C;">Welcome to AIGI Care Portal</h2>
        <p>Dear ${fullName},</p>
        <p>Your <strong>${roleDisplayName}</strong> account has been created. To get started, please set your password by clicking the button below.</p>
        <p style="color: #555;">This link is valid for <strong>24 hours</strong> and can only be used once.</p>
        <div style="text-align: center; margin: 32px 0;">
          <a href="${setupUrl}"
             style="background-color: #024C9C; color: white; padding: 14px 36px;
                    text-decoration: none; border-radius: 6px; display: inline-block; font-weight: 600; font-size: 15px;">
            Set Your Password
          </a>
        </div>
        <p>Your login email: <strong>${email}</strong></p>
        <p>Login page: <a href="https://admin.aigicare.com/admin/login" style="color: #024C9C;">https://admin.aigicare.com/admin/login</a></p>
        <p style="margin-top: 30px;">Thank you,<br/>AIGI Care Team</p>
        <hr style="border: none; border-top: 1px solid #eee; margin: 20px 0;" />
        <p style="color: #999; font-size: 11px;">This is an automated message. Do not share this link. If you did not expect this email, please contact your administrator immediately.</p>
      </div>
    `;
    fetchWithAppCheck('https://us-central1-aigicare-prod.cloudfunctions.net/sendGenericEmail', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to: email,
        subject: 'Welcome to AIGI Care Portal — Set Your Password',
        html: welcomeHtml,
      }),
    }).catch(() => {});

    setShowLoader(false);
    setError('');
    handleCancel();
    
  } catch (error) {
    logger.error('Error creating admin:', error);
    toast.error(error.message || 'Failed to create admin', {
      position: toast.POSITION.TOP_RIGHT,
    });
    setError('');
    setShowLoader(false);
  }
};

 

const handleCancel = () => {
  let path = `/admin/adminusers`;
  navigate(path); 
  setIsEditing(false);
  setError('')
};

const handleFullNameChange = (event) => {
  // Remove non-text characters from the input value
  const value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
  setFullName(value);   
};

  return (
    <div>
    <div className='container-fluid p-0 adminDashboardMain'>
      <SideBarMenu/>
    
      <div className='container-fluid p-0 contentBody'>
           <Header />
           <div className="innerBodyBox bgInnerDiv">

            <div className="contentInnerBody">
        <div className=' p-0    '>  
        <div className='loginBoxDiv ForgotPassswordMain UserProfileMain whiteBgColor centerDivAlign addAdminUser'> 
        <h2>Add Admin Details </h2>  
       <form onSubmit={handleSubmitProfile}> 
       <fieldset className='editUserProfile'  id="sign_up" >
          <div className='inputDivBox' >
            <label>Full Name:</label>
              <div className={"inputTxtBox registerInputDiv   "}>
                    <img src={Icons[0].userImg} className="logoImg" alt="" />
                    <input type="text" value={fullName} placeholder="Full Name" onChange={handleFullNameChange} maxLength="100" />
            </div>
            {error.fullName && <span  className="errorTxt" >{error.fullName}</span>}
          </div>
          <div className='inputDivBox' >
            <label>Email:</label>
             <div className={"inputTxtBox registerInputDiv  "}>
                    <img src={Icons[0].mailImg} className="logoImg" alt="" />
                    <input type="email" value={email} placeholder="Email id" autoComplete="email" onChange={handleEmailChange}    /> 
                  </div>
                  {error.email && <span  className="errorTxt" >{error.email}</span>}
          </div>
          {/* Password is set by the new admin via a secure email link — not entered here */}
          <div className='inputDivBox' >
            <label>Role:</label>
            <div className={"inputTxtBox registerInputDiv"}>
              <img src={Icons[0].admin_adminIcon} className="logoImg" alt="" />
              <select value={roleTxt} onChange={(e) => setRoleTxt(e.target.value)} style={{ fontSize: '16px', background: 'transparent', border: 0, width: 'calc(100% - 60px)', position: 'absolute', right: '10px', cursor: 'pointer', appearance: 'auto', color: roleTxt ? '#000' : '#999' }}>
                <option value="" disabled>Select Role</option>
                {Object.entries(ADMIN_PORTAL_ROLES).map(([value, label]) => (
                  <option key={value} value={value} style={{ color: '#000' }}>{label}</option>
                ))}
              </select>
            </div>
            {error.roleTxt && <span className="errorTxt">{error.roleTxt}</span>}
          </div>
          <div className='inputDivBox' >
            <label>Phone Number:</label>
            <div className={"registerInputDiv "+ (isEditing ? '' : 'disabled')}>
                    <PhoneInput
                      autocomplete="off" 
                      defaultCountry="US"
                      country={"us"}
                     id="phone"
                     placeholder="Enter phone number"
                     value={phoneNumber}
                     onChange={setPhoneNumber} 
                     international={false} 
                     inputProps={{
                       name: 'phone',
                       required: true,
                       autoFocus: true, 
                       autoComplete: 'off',
                     }}  
                     disabled={isEditing ? '' : 'true'}
                    />
                  </div> 
                  {error.phoneNumber && <span  className="errorTxt" >{error.phoneNumber}</span>}
          </div>
          <div className='inputDivBox' >
            <label>Date of Birth:</label> 
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                        <img src={Icons[0].dateIcon} className="logoImg" alt="" />
                        <input type="text"    value={DOBTxt} placeholder="Date of Birth (YYYY-MM-DD)" readOnly /> 
                        <button type="button" className={"toggleCalendarBtn " + (isEditing ? '' : 'd-none')}  disabled={isEditing ? '' : 'true'}  onClick={toggleCalendar}> <img src={Icons[0].calendarIcon} className="logoImg" alt="" /></button>
                          {showCalendar && (
                              <Calendar
                                className= 'inputCaledar'
                                onChange={onChangeCalendar}
                                value={parseDOBToDate(DOBTxt)}
                                maxDate={moment().subtract(18, 'years').toDate()}
                              />
                          )}
                   </div>
                  {error.DOBTxt && <span  className="errorTxt" >{error.DOBTxt}</span>} 
          </div>
          <div className='inputDivBox' >
            <label>Specialty:</label> 
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                    <img src={Icons[0].InsuranceIDIcon} className="logoImg" alt="" />
                     <input type="text" value={specialty} placeholder="Specialty"  disabled={isEditing ? '' : 'true'} onChange={(e) => setSpecialty(e.target.value)}   maxLength="100" /> 
                  </div>
                  {error.specialty && <span  className="errorTxt" >{error.specialty}</span>} 
          </div>
          <div className='inputDivBox' >
            <label>Gender:</label>
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                        <img src={Icons[0].GenderImg} className="logoImg" alt="" />
                        <input type="text" value={GenderTxt} placeholder="Sex" onChange={handleGenderChange} maxLength="1" disabled={isEditing ? '' : 'true'}
                        onKeyUp={(e) => { if (e.key === 'Backspace') { setGenderTxt('');  } }}/> 
            </div>
            {error.GenderTxt && <span  className="errorTxt" >{error.GenderTxt}</span>} 
          </div>
        
       
         
          </fieldset>
{
  isEditing ? (<>
  <div className={"saveOptDivBox "}>
          {ShowLoader ? (<>
                      <button  className="   " > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button onClick={handleSubmitProfile} type="submit" >Save</button>
                    </>)} 
                  <button type="button" onClick={handleCancel}>Cancel</button>
            </div>
  </>) : ('')
}
          
          
        </form>
     

                 
      </div>
         </div>
    </div> 
    </div> 
    </div> 
    </div> 
    </div> 
  );
}

export default AddAdminUser;
